import blog from "./assets/icons/BlogMt.svg";
import order from "./assets/icons/OrderMt.svg";
import customer from "./assets/icons/CustomerMt.svg";
import catlog from "./assets/icons/CatelogMt.svg";
import testimonals from "./assets/icons/TestMt.svg";
import shipping from "./assets/icons/ShipMt.svg";
import banner from "./assets/icons/BannerMt.svg";
import brand from "./assets/icons/BrandMt.svg";
import user from "./assets/icons/UserMt.svg";
import cart from "./assets/icons/CartMt.svg";
import coupon from "./assets/icons/CouponMt.svg";
import appointmnet from "./assets/icons/AppointmentMt.svg";
import store from "./assets/icons/StoreMt.svg";
import staticMt from "./assets/icons/StaticMt.svg";
import settings from "./assets/icons/SettingMt.svg";
import report from "./assets/icons/ReportMt.svg";

export const MONTH_LIST = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const orderTabConfig = {
  0: "Booked",
  1: "Confirmed",
  2: "Shipped",
  3: "Delivered",
  4: "Cancelled",
  5: "Returns",
  6: "All",
};
export const sideBarData = [
  {
    label: "User Management",
    to: "/admin/user",
    img: user,
  },
  {
    label: "Order Management",
    to: "/admin/list-order",
    img: order,
  },
  {
    label: "Customer Management",
    to: "/admin/list-customer",
    img: customer,
  },
  {
    label: "Banner Management",
    to: "/admin/list-banner",
    img: banner,
  },
  {
    label: "Brand Management",
    to: "/admin/list-static",
    img: brand,
  },
  {
    label: "Shipping Configuration",
    to: "/admin/list-shipping",
    img: shipping,
  },

  {
    label: "Catalog Management",
    to: "/admin/list-catlog",
    img: catlog,
  },
  {
    label: "Cart Management",
    to: "/admin/list-cart",
    img: cart,
  },
  {
    label: "Coupon Management",
    to: "/admin/list-coupon",
    img: coupon,
  },

  {
    label: "Appointment Management",
    to: "/admin/list-appointments",
    img: appointmnet,
  },

  {
    label: "Blog Management",
    to: "/admin/list-blogs",
    img: blog,
  },

  {
    label: "Store Location",
    to: "/admin/list-store",
    img: store,
  },
  {
    label: "Static Page Management",
    to: "/admin/staticpage-management",
    img: staticMt,
  },
  {
    label: "Testimonials",
    to: "/admin/list-testimonials",
    img: testimonals,
  },
  {
    label: "Site Settings",
    to: "/admin/settings",
    img: settings,
  },
  {
    label: "Reports",
    to: "/admin/list-reports",
    img: report,
  },
];
export const ORDER_STATUS = {
  DELIVERED: "DELIVERED",
  BOOKED: "BOOKED",
  CONFIRMED: "CONFIRMED",
  SHIPPED: "SHIPPED",
  CANCELLED: "CANCELLED",
  LEAD: "LEAD",
  RETURNS: "RETURNS",
};

export const RETURN_STATUS = {
  REQUESTED: "REQUESTED",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  COMPLETED: "COMPLETED",
};
